import { JsonPipe } from "@angular/common";
import { Component } from "@angular/core";
import { TranslatePipe, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/manual/i18n/scope";
import { ApiSpecificationModel } from "@app/manual/models/api-models/api-specification-model";
import { ApiSpecComponent } from "../../api-spec";

@Component({
    selector: "app-control-get-teststep-document-api-manual",
    templateUrl: "../../api-spec.html",
    styleUrls: ["../../api-spec.scss"],
    standalone: true,
    imports: [JsonPipe, TranslatePipe],
    viewProviders: [provideTranslationScope(scope)]
})
export class ControlGetTeststepsDocumentApiManualComponent extends ApiSpecComponent {
    initSpecs(): ApiSpecificationModel {
        return <ApiSpecificationModel>{
            name: this.translation.t("specs.controlGetTeststepDocument"),
            description: this.translation.t("specs.controlGetTeststepDocumentDescription"),
            httpMethod: "GET",
            path: "controls/testing/advanced/effectiveness/automation/samples/teststep/documents/{documentId}",

            parameters: [
                {
                    name: "documentId",
                    description: this.translation.t("parameters.controlDocumentIdDescription"),
                    in: "path",
                    paramType: "uuid",
                    required: true,
                    example: "00000000-0000-0000-0000-000000000000",
                },
            ],

            responses: [
                {
                    code: "200",
                    description: "OK",
                    example: "binary data",
                },
            ],
        };
    }
}
